import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

interface GenericWidgetFooterProps {
  children?: ReactNode
  sx?: SxProps
}

const GenericWidgetFooter = (props: GenericWidgetFooterProps) => {
  const { children, sx } = props

  return (
    <Box
      sx={{
        position: 'relative',
        ...sx
      }}
    >
      {children}
    </Box>
  )
}

export default GenericWidgetFooter
